export enum TransactionFormType {
  Classic = 'Classic',
  FastOrder = 'FastOrder',
}
